<template>
  <div class="" v-if="broker != null">
    <div class="text-base">
      We're almost there. Lastly, let's add some contact details for your client.
    </div>

    <div class="flex flex-wrap -mx-2 mt-8">
      <div class="w-1/2 px-2">
        <InputEmail 
          label="Email address" 
          propertyKey="email"
          objectType="application"
          :value="application.email"
          :updateValue="updateValue"
          :copyFrom="'email'" />
      </div>

      <div class="w-1/2 px-2">
        <InputPhone label="Mobile phone" 
          propertyKey="mobilePhone"
          objectType="application"
          :value="application.mobilePhone"
          :updateValue="updateValue"
          :copyFrom="'mobilePhone'" />
      </div>
    </div>

    <div class="text-center mt-20 flex items-center justify-center">
      <div class="inline-block bg-green-600 w-3 h-3 rounded-full"></div>
      <div class="inline-block bg-gray-200 w-12 mx-2" style="height:2px;"></div>
      <div class="inline-block bg-green-600 w-3 h-3 rounded-full"></div>
      <div class="inline-block bg-gray-200 w-12 mx-2" style="height:2px;"></div>
      <div class="inline-block bg-green-600 w-3 h-3 rounded-full"></div>
    </div>

    <div class="mt-4 text-xs">
      <table class="w-full">
        <tr>
          <td class="w-1/3">
            <router-link 
              :to="{
                name  : 'broker-onboard-first-client-two',
                params: {
                  brokerId: $route.params.brokerId,
                  data    : encodeURIComponent(JSON.stringify(this.application))
                }
              }"
              tag="a" 
              class="rounded px-4 py-2 text-xs bg-gray-500 hover:bg-gray-600 text-white float-left">
              <svg width="16" height="16" stroke-width="2" class="float-left" style="margin-top:1px;" stroke="currentColor" fill="none">
                <use xlink:href="/static/img/feather-sprite.svg#chevron-left"/>
              </svg>
              Back
            </router-link>
          </td>
          <td class="w-1/3">
            <div class="text-gray-600 text-center">Step 3 of 3</div>
          </td>
          <td class="w-1/3">
            <button
              @click.prevent="next()"
              class="rounded px-4 py-2 text-xs float-right bg-blue-500 hover:bg-blue-600 text-white">

              <span class="float-left">Next</span>

              <svg width="16" height="16" stroke-width="2" class="float-left" style="margin-top:1px;" stroke="currentColor" fill="none">
                <use xlink:href="/static/img/feather-sprite.svg#chevron-right"/>
              </svg>
            </button>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  import { EventBus }   from '@/shared/event-bus'
  import InputEmail     from '@/shared/components/form/InputEmail'
  import InputPhone     from '@/shared/components/form/InputPhone'
  import SubmitButton2  from '@/shared/components/form/SubmitButton2'
  
  export default {

    components: {
      InputEmail,
      InputPhone,
      SubmitButton2,
    },

    data () {
      return {
        loading    : false,
        broker     : null,
        application: {
          email      : null,
          mobilePhone: null
        }
      }
    },

    created() {
      this.getBroker({
        brokerId: this.$route.params.brokerId
      }, (broker) => {
        this.broker = broker
      })

      if(this.$route.params.data != null) {
        this.application = JSON.parse(decodeURIComponent(this.$route.params.data))
      }

      if(this.application.email == null) {
        this.application.email = null
      }

      if(this.application.mobilePhone == null) {
        this.application.mobilePhone = null
      }
    },

    methods : {
      updateValue(params) {
        this.application[params.key] = params.value
      },

      next() {
        this.apiPost({
          application : this.application
        }, 'client/create-via-onboarding', (data) => {
          this.application.clientId    = data.client.id
          this.application.applicantId = data.applicant.id

          this.$router.push({
            name  : 'broker-onboard-first-client-done',
            params: {
              brokerId: this.broker.id,
              data    : encodeURIComponent(JSON.stringify(this.application))
            }
          })
        })
      }
    },
  }
</script>